import axios from 'axios';
import API from './constants/API';

const AxiosInstance = axios.create({
  baseURL: API.BASE_URL,
  headers: {
    'content-type': 'application/json , text/plain',
  },
});

AxiosInstance.interceptors.request.use(
  (request) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.data?.result?.access_token;
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => Promise.reject(error)
);

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // store.dispatch(logoutUser());
    }

    return Promise.reject(error);
  }
);
export default AxiosInstance;
